import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Index = resolve => require(['@/page/Index.vue'], resolve)
const MOBILE = resolve => require(['@/page/mobile.vue'], resolve)
const CONNECT = resolve => require(['@/page/connect.vue'], resolve)
const ABOUT = resolve => require(['@/page/about.vue'], resolve)

export default new Router({
    routes: [
        /****************************/
        //首页
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        //移动端首页
        {
            path: '/mobile',
            name: 'Mobile',
            component: MOBILE
        },
        //关于我们
        {
            path: '/about',
            name: 'About',
            component: ABOUT
        },
        //联系我们
        {
            path: '/connect',
            name: 'Connect',
            component: CONNECT
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js